// removed by extract-text-webpack-plugin
module.exports = {"moodysBlue":"#009bdf","darkCoral":"#f46036"};


//////////////////
// WEBPACK FOOTER
// ./src/spread/chartOfAccounts/reject/RejectPopover.scss
// module id = 2244
// module chunks = 0